const translations = {
  'homepage.seo.title': 'TEFL Courses in Barcelona, Spain | Trinity CertTESOL',
  'homepage.seo.description':
    'The best TEFL courses in Barcelona, Spain, from TEFL Iberia. Apply online. Our 160-hour TEFL course is only €1550 with an early-bird discount!',
  'homepage.sec1.title': 'Train as an English teacher in Spain and Unlock a World of Possibilities',
  'homepage.sec1.description':
    ' Enroll with TEFL Iberia and start your training in Barcelona.',
  'homepage.sec2.title': 'TEFL IBERIA IS AFFILIATED WITH',
  'homepage.sec3.title': 'TEFL Iberia Helps Students Thrive. Here’s How:',
  'homepage.sec3.ben1.title': 'Internationally Recognized Qualification',
  'homepage.sec3.ben1.text':
    'Barcelona? Bangkok? Brazil? Trinity CertTESOL is accepted across the globe.',
  'homepage.sec3.ben2.title': 'Classroom Confidence Building',
  'homepage.sec3.ben2.text':
    ' Because teaching English involves more than just mastering the material.',
  'homepage.sec3.ben3.title': 'Post-Grad Job Prospects',
  'homepage.sec3.ben3.text':
    'We work hard to make sure all of our students find relevant work after graduation.',
  'homepage.sec3.ben4.title': 'Varied Learning Styles',
  'homepage.sec3.ben4.text':
    'Variety is the spice of life and a key ingredient of our innovative lesson plans.',
  'homepage.sec3.ben5.title': 'Small Group Sizes',
  'homepage.sec3.ben5.text': 'Our TEFL classes max out at 12, giving everybody access to an instructor.',
  'homepage.sec5.title':
    'We’ve Helped Thousands of Students Learn to Teach English. <accent> Are You Next?</accent>',
  'homepage.sec5.description':
    'Students come from all over the world to train with TEFL Iberia, eager to experience the adventure of living in Spain, the benefits of learning to teach, and the opportunity to make a difference teaching English internationally.',
  'homepage.sec5.i1.title': '1000+',
  'homepage.sec5.i1.text': 'Student success stories since 2012',
  'homepage.sec5.i2.title': '60+',
  'homepage.sec5.i2.text': 'Nationalities represented by our alumni',
  'homepage.sec5.i3.title': '20%',
  'homepage.sec5.i3.text': 'Of our TEFL students are not native speakers',
  'homepage.sec6.title': 'Got Questions? Ask Us Anything',
  'homepage.sec6.downloadBrochure': 'Download Brochure',
  'homepage.sec7.title': 'You’re Always in Good Hands!',
  'homepage.sec7.description':
    'TEFL Iberia is more than just an English teacher training school. Our amazing student support team helps with accommodation, visas, bureaucracy, settling in Barcelona, and more.',
  'homepage.sec7.i1.title': 'Accommodation',
  'homepage.sec7.i1.text':
    'We want your time in Barcelona to be memorable inside ​and​ outside of the  classroom. That’s why we place you in accommodation with other TEFL students on your  course or recent graduates.',
  'homepage.sec7.i2.title': 'Student visas',
  'homepage.sec7.i2.text':
    'Need help understanding your student visa requirements in Spain and navigating  the application process? The TEFL Iberia team is always available to lend a  qualified hand.',
  'homepage.sec7.i3.title': 'Careers advice',
  'homepage.sec7.i3.text':
    'Find your dream job with TEFL Iberia. Our tutors have over 30 years of combined international experience and built up a world-class network of contacts - in Barcelona and beyond.',
  'homepage.sec7.i.findOutMore': 'Find out more',
  'homepage.sec8.title': 'Latest From our Blog',
  'homepage.sec8.seeAllPosts': 'See all posts',
  'homepage.sec9.title': 'Ready to Take the First Steps Towards <accent> Your New Career?</accent>',
  'homepage.sec9.description':
    'It’s now easier than ever to become an international TEFL teacher. Apply now and start working towards your own dream job today.',
};

export default translations;
